import { render, staticRenderFns } from "./AffiliatePayoutHistoryModal.vue?vue&type=template&id=c4a81e54&scoped=true&"
import script from "./AffiliatePayoutHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./AffiliatePayoutHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliatePayoutHistoryModal.vue?vue&type=style&index=0&id=c4a81e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a81e54",
  null
  
)

export default component.exports